import { useState, useEffect } from 'react'
import { eventSocialService } from '../services/friendsService'

export const useFriendsEvents = () => {
  const [events, setEvents] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  const fetchFriendsEvents = async () => {
    try {
      setLoading(true)
      const data = await eventSocialService.getFriendsEvents()
      setEvents(data.events || [])
      setError('')
    } catch (err) {
      if (process.env.NODE_ENV === 'development') console.error('Error fetching friends events:', err)
      setError('Failed to load friends events')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchFriendsEvents()
  }, [])

  return {
    events,
    loading,
    error,
    refetch: fetchFriendsEvents
  }
}